<template>
    <div>
        <el-card>
            <div style="margin-bottom: 16px;">
                <el-input v-model="form.keyword" placeholder="渠道名称" size="medium"
                    style="width: 200px; margin-right: 16px;" clearable />
                <el-button type="primary" size="medium" @click="handleSearch">搜索</el-button>
                <el-button size="medium" @click="reset">重置</el-button>
                <el-button type="primary"  v-if="$store.state.btn_if.indexOf('channel_add') != -1" size="small" @click="add">新增渠道</el-button>
            </div>
            <el-table :data="tableData" style="width: 100%" border stripe>
                <el-table-column prop="id" label="编号" width="80" />
                <el-table-column prop="name" label="渠道名称(点击短链可以直接复制)">
                    <template slot-scope="ew">
                        <p>
                            {{ ew.row.name }}
                        </p>
                        <a v-if="ew.row.sunCode" :href="ew.row.sunCode" target="“_blank”">(渠道二维码)</a>
                        <p v-if="ew.row.shortUrl" style="cursor: pointer;" @click="copyToClipboard(ew.row.shortUrl)">
                            {{ ew.row.shortUrl }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="using" label="渠道用途" />
                <el-table-column prop="couponName" label="优惠券名称" />
                <el-table-column prop="activityTitle" label="活动">

                </el-table-column>
                <el-table-column prop="landingPage" label="渠道落地页">
                    <template slot-scope="ew">

                        <p v-if="ew.row.landingPage">
                            {{ ew.row.landingPageTxt }}
                        </p>
                    </template>
                </el-table-column>
                 <el-table-column prop="remark" label="备注">
                    <template slot-scope="ew">

                       <Remark :changeData="false"  :row="ew"
                                :val="{ url: '/admin/Activity/channelRemark', pw: 'channel_remark' }"
                                :getlist="getlist" />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="ew">
                        <el-button type="text" size="mini"  v-if="$store.state.btn_if.indexOf('channel_edit') != -1" @click="editChannel(ew.row)">编辑</el-button>
                        <el-button type="text" size="mini"  v-if="$store.state.btn_if.indexOf('channel_del') != -1" style="color: red;"
                            @click="deleteChannel(ew.row)">删除</el-button>
                    </template>

                </el-table-column>
            </el-table>
            <div style="margin-top: 16px; text-align: right;">
                <el-pagination :current-page="form.page" :page-size="form.pageSize" :total="total"
                    layout="total, prev, pager, next" @current-change="handleCurrentChange" />
            </div>
        </el-card>
        <Dialog :id="12" ref="dialogRef" :cet="true" :title="'新增渠道'" @getlist="getlist" />

    </div>
</template>

<script>
import { title } from 'echarts/lib/theme/dark';


export default {
    data() {
        return {
            form: {
                keyword: "",
                page: 1,
                pageSize: 10,
                activityId: "",
            },
            total: 0,
            tableData: [],
            disabled: false,
        }
    },
    created() {
        if (this.$route.query.activityId) {
            this.form.activityId = this.$route.query.activityId
        }
        this.getlist();
    },
    components: {
        Dialog: () => import('@/components/popup.vue'),
    },
    methods: {
        reset() {
           Object.assign(this.$data, this.$options.data.call(this));
            this.getlist();
        },
        async deleteChannel(row) {
            this.$confirm(`确定删除"${row.name}"这个渠道吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .get("/admin/Activity/channelDel", {
                        params: {
                            id: row.id
                        },
                    })
                    .then(({ data: res }) => {
                        if (res.errorCode == 200) {
                            this.getlist();
                        }
                    });
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        add() {
            this.$refs.dialogRef.dialogVisible = true
            this.$refs.dialogRef.edit = false
            this.$refs.dialogRef.form = {
                name: '',
                isSendBonus: 0,
                limit: 0,
                using: '',
                couponId: '',
                landingPage: '',
                // activityId: this.$route.query.id
            }
        },
        editChannel(row) {
            this.$refs.dialogRef.edit = true
            this.$refs.dialogRef.form = {
                ...row
                // name: row.name,
                // isSendBonus: 0,
                // limit: 0,
                // using: '',
                // couponId: '',
                // landingPage: '',
                // activityId: this.$route.query.id
            }
            this.$refs.dialogRef.dialogVisible = true
            this.$refs.dialogRef.init({ activityId: row.activityId, activityTitle: row.activityTitle }, { couponId: row.couponId, couponName: row.couponName })
        },
        handleSearch() {
            this.form.page = 1
            this.getlist();
        },
        /**
         * 复制文本到剪贴板，支持现代浏览器和降级方案。
         * @param {string} text 要复制的文本
         */
        copyToClipboard(text) {
            if (this.fallbackCopy(text)) {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: '复制失败',
                    type: 'error'
                });
            }
        },
        fallbackCopy(text) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            // 使 textarea 不可见且不影响布局
            textarea.style.position = 'fixed';
            textarea.style.top = '-9999px';
            textarea.style.left = '-9999px';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            textarea.setSelectionRange(0, text.length); // 对移动端兼容
            let success = false;
            try {
                success = document.execCommand('copy');
            } catch (err) {
                console.error('execCommand 复制失败:', err);
            }
            document.body.removeChild(textarea);
            return success;
        },
        handleCurrentChange(e) {
            this.form.page = e
            this.getlist();
        },
        getlist() {
            this.$http
                .get("/admin/Activity/getChannelListNew", {
                    params: {
                        ...this.form
                    },
                })
                .then(({ data: res }) => {
                    if (res.errorCode == 200) {
                        this.tableData = res.data.list;
                        this.total = res.data.totalCount;
                    }
                });
        },
    },
}
</script>

<style lang="less"></style>
